import React from 'react';
import PropTypes from 'prop-types';

const EmergencyPolicyPage = () => {

  return (
    <div style={{ fontFamily: "Elef Layla MF", padding: "20px", maxWidth: "800px", margin: "0 auto", lineHeight: "1.2",fontSize: "16pt" }}>

      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "18pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: "2px solid black",
            paddingBottom: "0px",
          }}
        >
           Emergency & Non-Emergency Policy and Procedure
        </h2>
      </div>
      

      {/* Emergency Situations */}
      <section style={{ marginBottom: '20px' }}>
        <p style={{ marginBottom: '10px' }}>In case of:</p>
        <ol style={{ paddingLeft: '20px', marginBottom: '15px' }}>
          <li>Fire – Exit all apartments immediately and make your way to the front parking lot on the East side of the building. Walk across the street and stand on the sidewalk, wait for help to arrive.</li>
          <li>A life-threatening medical situation</li>
          <li>Chest pain</li>
          <li>Shortness of breath</li>
          <li>Suicide attempt</li>
          <li>Unconscious individual</li>
          <li>Injury in which there is a broken bone or bleeding that cannot be stopped</li>
          <li>Serious fall</li>
          <li>Unable to wake someone</li>
          <li>Ingestion of toxic chemicals or substances</li>
          <li>Individual out of control</li>
          <li>Individual hallucinating</li>
          <li>Individual having an extreme allergic reaction</li>
          <li>In the event of an Overdose</li>
        </ol>

        <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
          After you call 911 then call the house managers:
        </p>
        <ul style={{ paddingLeft: '20px', marginBottom: '15px' }}>
          <li>Christen Iacovino - 954-609-6856</li>
          <li>CRRA Neal Cooke - (954) 242-1059</li>
        </ul>

        <p style={{  marginBottom: '15px' }}>
  <span style={{ fontWeight: 'bold' }}>DO NOT</span> try to move an injured person, give First Aid or CPR unless you are qualified.
</p>

      </section>

      {/* NARCAN Policy */}
      <section style={{ marginBottom: '20px' }}>
        <h2 style={{
          fontSize: '12pt',
          fontWeight: 'bold',
          marginBottom: '10px'
        }}>
          Overdose / NARCAN Policy:
        </h2>
        <p style={{ marginBottom: '10px'}}>
  <span style={{ fontWeight: 'bold' }}>All</span>{' '}
  residents of Legacy Healing Center Margate, LLC must sign the waiver allowing a staff member to administer NARCAN in the event of a suspected overdose. In the event of a suspected overdose immediately call 911. After calling 911 grab NARCAN, administer, and wait until help arrives. After the medics arrive, make sure to let them know that NARCAN was administered, and the amount given.
</p>

      </section>

      {/* Hurricane Policy */}
      <section style={{ marginBottom: '20px' }}>
        <p style={{ marginBottom: '10px' }}>
        <span style={{ fontWeight: 'bold' }}> In the event of a hurricane</span> Legacy Healing Center Margate will take all necessary precautions and do everything possible to keep you safe. If you are uncomfortable staying at the residence and would like to stay with an approved family member or friend, arrangements can be made.
        </p>
      </section>

      {/* House Manager Calls */}
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '14pt',
          fontWeight: 'bold',
          marginBottom: '10px'
        }}>
          Call the House Manager in case of:
        </h2>
        <ol style={{ paddingLeft: '20px' }}>
          <li>Drugs, alcohol, weapons, or pornography on the premises</li>
          <li>Suspicion or knowledge of someone using/having used drugs/alcohol</li>
          <li>Plumbing problems</li>
          <li>Power out for more than 5 minutes</li>
          <li>Unable to turn off alarm</li>
          <li>Individual who may be in withdrawal having difficulties</li>
          <li>Curfew violations</li>
          <li>Violence or threatening situations between residents</li>
        </ol>
      </section>
    </div>
  );
};

EmergencyPolicyPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default EmergencyPolicyPage;